import { message } from "antd";
import errCode, { GetErrMsg } from "./errCode";
import store from "../redux/store";
import { CheckSystem, getDeviceType } from "../common/globalFun";
import { SESSION_STORAGE_INVITE_CODE } from "../common/const";

import API, { API_V5 } from "./api";
const md5 = require("js-md5");
const isFeloClient = CheckSystem.Felo();
const DeviceType = getDeviceType();

const getRandomPwd = () => {
  return Math.random().toString().slice(-8);
};

const getToken = () => {
  const state = store.getState();
  return state.token;
};

const getLang = () => {
  const state = store.getState();
  return state.lang;
};

const getTimezone = () => {
  const state = store.getState();
  return state.timezone;
};

const COMMON_HEADER = {
  Accept: "application/json",
  "Content-Type": "application/json",
  timestamp: new Date().getTime().toString(),
};

// V3
export const CreateFeloTeam = ({ name }) => {
  const token = getToken();
  return new Promise((resolve, reject) => {
    const url = API.CREATE_TEAM;
    const param = {
      name: name,
    };
    fetch(url, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(
        Object.assign(COMMON_HEADER, {
          token: token,
        })
      ),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.errCode === errCode.OK) {
          resolve(rsp);
        } else {
          reject();
          message.error(GetErrMsg(rsp.errCode));
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

// V5
export const GetLoginStatus = (param) => {
  return new Promise((resolve, reject) => {
    let url = API_V5.GET_LOGIN_STATUS;
    if (param) {
      url += "?";
      for (const key in param) {
        url = `${url}${key}=${param[key]}&`;
      }
      url = url.slice(0, -1);
    }
    fetch(url, {
      method: "GET",
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          if (param) {
            resolve({
              status: rsp.data.status,
              accountList: rsp.data.account_list,
            });
          } else {
            resolve({
              isLogin: rsp.data.status == 1,
              hasInvite: rsp.data.email_invite_status == 1,
            });
          }
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostEmailCheck = ({ account, code }) => {
  return new Promise((resolve, reject) => {
    const url = API_V5.POST_EMAIL_CHECK;
    const param = {
      account: account,
      code: code,
      device_type: DeviceType,
    };

    fetch(url, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          const { register_status, email_check_key } = rsp.data;
          resolve({ status: register_status, checkKey: email_check_key });
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostEmailVerify = ({ email, verify_code, invite_code,code, lang }) => {
  return new Promise((resolve, reject) => {
    const url = API_V5.POST_EMAIL_VERIFY;
    const param = {
      email: email,
      verify_code,
      invite_code,
      lang,
      code
    };

    fetch(url, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve(rsp);
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostTeamJoin = ({ account, invite_code, isFromClient }) => {
  const token = getToken();
  return new Promise((resolve, reject) => {
    let url, param;
    if (isFromClient) {
      url = API.JOIN_ORG;
      param = {
        email: account,
        inviteCode: invite_code,
        isRegister: 0,
      };
    } else {
      url = API_V5.POST_TEAM_JOIN;
      param = {
        account: account,
        invite_code: invite_code,
        lang: getLang(),
        timezone: getTimezone(),
        code: window.sessionStorage.getItem("recommend"),
      };
    }

    fetch(url, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(
        Object.assign(COMMON_HEADER, {
          token: token,
        })
      ),
    })
      .then((response) => response.json())
      .then((rsp) => {
        sessionStorage.removeItem(SESSION_STORAGE_INVITE_CODE);

        if (isFromClient) {
          if (rsp.errCode == errCode.OK) {
            resolve(rsp);
          } else {
            reject(rsp);
            message.error(GetErrMsg(rsp.errCode));
          }
        } else {
          if (rsp.status.ok) {
            resolve(rsp.data);
          } else {
            reject();
            message.error(
              GetErrMsg(
                rsp.status.err_code,
                rsp.status.err_metadata.messages[0]
              )
            );
          }
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostUserAdd = ({ account, userName }) => {
  const token = getToken();
  return new Promise((resolve, reject) => {
    const url = API_V5.POST_USER_ADD;
    const param = {
      account: account,
      user_name: userName,
    };

    fetch(url, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(
        Object.assign(COMMON_HEADER, {
          token: token,
        })
      ),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve();
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostTeamCreate = ({ account, teamName, username }) => {
  return new Promise((resolve, reject) => {
    const url = API_V5.POST_TEAM_CREATE;
    const param = {
      account: account,
      team_name: teamName,
      lang: getLang(),
      timezone: getTimezone(),
      code: window.sessionStorage.getItem("recommend"),
    };
    fetch(url, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve(rsp.data);
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostEmailInvite = ({ accounts, lang, corpId, token, email }) => {
  return new Promise((resolve, reject) => {
    let url, param;
    if (isFeloClient) {
      url = API.INVITE;
      param = {
        emails: accounts,
        lang: lang,
        deviceType: "web", // 接口根据这个字段判断是否使用JWT token解析
        corpId: corpId,
      };
    } else {
      url = API_V5.POST_EMAIL_INVITE;
      param = {
        emails: accounts,
        account: email,
        team_id: corpId,
      };
    }

    fetch(url, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(
        Object.assign(COMMON_HEADER, {
          token: token,
        })
      ),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (isFeloClient) {
          if (rsp.errCode == errCode.OK) {
            resolve(rsp);
          } else {
            reject();
            message.error(GetErrMsg(rsp.errCode));
          }
        } else {
          if (rsp.status.ok) {
            const response = {
              data: {
                successEmailList: rsp.data.success,
                failedEmailList: rsp.data.failed,
              },
            };
            resolve(response);
          } else {
            reject();
            message.error(
              GetErrMsg(
                rsp.status.err_code,
                rsp.status.err_metadata.messages[0]
              )
            );
          }
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const GetTeamList = () => {
  return new Promise((resolve, reject) => {
    fetch(API_V5.GET_TEAM_LIST, {
      method: "GET",
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve(rsp.data);
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostTeamOpen = ({ account, teamIds }) => {
  return new Promise((resolve, reject) => {
    const param = {
      account,
      team_ids: teamIds,
    };
    fetch(API_V5.POST_TEAM_OPEN, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve();
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostTeamSwitch = ({ team_id }) => {
  return fetch(API_V5.POST_TEAM_SWITCH + "?team_id=" + team_id, {
    method: "GET",
    headers: new Headers(COMMON_HEADER),
  })
    .then((response) => response.json())
    .then((rsp) => {
      if (!rsp.status.ok) {
        const msg = GetErrMsg(
          rsp.status.err_code,
          rsp.status.err_metadata.messages[0]
        );

        throw new Error(msg);
      }
    })
    .catch((error) => {
      if (error instanceof Error) {
        message.error(error.message);
      } else {
        message.error(JSON.stringify(error));
      }

      throw error;
    });
};

export const GetInviteList = () => {
  return new Promise((resolve, reject) => {
    fetch(API_V5.GET_INVITE_LIST, {
      method: "GET",
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve(rsp.data);
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostInviteHandle = (param) => {
  param = Object.assign(
    {
      lang: getLang(),
      timezone: getTimezone(),
    },
    param
  );
  return new Promise((resolve, reject) => {
    fetch(API_V5.POST_INVITE_HANDLE, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve();
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostAuthLogin = (param) => {
  return new Promise((resolve, reject) => {
    fetch(API_V5.POST_AUTH_LOGIN, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          const {
            register_status,
            need_mfa_check,
            email_invite_status,
            recheck_key,
            login_key,
          } = rsp.data;
          resolve({
            status: register_status,
            mfaCheck: need_mfa_check,
            inviteStatus: email_invite_status,
            recheckKey: recheck_key,
            loginKey: login_key,
          });
        } else {
          reject({
            code: rsp.status.err_code,
            msg: GetErrMsg(
              rsp.status.err_code,
              rsp.status.err_metadata.messages[0]
            ),
          });
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostEmailSend = (param) => {
  return new Promise((resolve, reject) => {
    fetch(API_V5.POST_EMAIL_SEND, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve({
            code: rsp.status.err_code,
            msg: "",
          });
        } else {
          reject({
            code: rsp.status.err_code,
            msg: GetErrMsg(
              rsp.status.err_code,
              rsp.status.err_metadata.messages[0]
            ),
          });
        }
      })
      .catch((error) => {
        reject({
          code: undefined,
          msg: error.toString(),
        });
      });
  });
};

// 发送注册验证码
export const PostEmailRegisterSend = (param) => {
  return new Promise((resolve, reject) => {
    fetch(API_V5.POST_EMAIL_REGISTER_SEND, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve({
            code: rsp.status.err_code,
            msg: "",
          });
        } else {
          reject({
            code: rsp.status.err_code,
            msg: GetErrMsg(
              rsp.status.err_code,
              rsp.status.err_metadata.messages[0]
            ),
          });
        }
      })
      .catch((error) => {
        reject({
          code: undefined,
          msg: error.toString(),
        });
      });
  });
};

// 验证邮箱是否注册
export const PostEmailRegisterCheck = (param) => {
  return new Promise((resolve, reject) => {
    fetch(API_V5.POST_REGISTER_EMAIL_CHECK, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve(rsp.data);
        } else {
          reject({
            code: rsp.status.err_code,
            msg: GetErrMsg(
              rsp.status.err_code,
              rsp.status.err_metadata.messages[0]
            ),
          });
        }
      })
      .catch((error) => {
        reject({
          code: undefined,
          msg: error.toString(),
        });
      });
  });
};

// 创建账号
export const CreateUser = (param) => {
  return new Promise((resolve, reject) => {
    fetch(API_V5.POST_CREATE_USER, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve(rsp.data);
        } else {
          reject({
            code: rsp.status.err_code,
            msg: GetErrMsg(
              rsp.status.err_code,
              rsp.status.err_metadata.messages[0]
            ),
          });
        }
      })
      .catch((error) => {
        console.log("erro", error, error.toString());
        reject({
          code: undefined,
          msg: error.toString(),
        });
      });
  });
};

export const PostPasswordSet = (param) => {
  return new Promise((resolve, reject) => {
    fetch(API_V5.POST_PASSWORD_SET, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          resolve();
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostMfaCheck = (param) => {
  return new Promise((resolve, reject) => {
    fetch(API_V5.POST_MFA_CHECK, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          const { register_status, email_invite_status, login_key } = rsp.data;
          resolve({
            status: register_status,
            inviteStatus: email_invite_status,
            loginKey: login_key,
          });
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};

export const PostGetLoginKey = (param) => {
  return new Promise((resolve, reject) => {
    fetch(API_V5.POST_GET_LOGIN_KEY, {
      method: "POST",
      body: JSON.stringify(param),
      headers: new Headers(COMMON_HEADER),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.status.ok) {
          const { login_key } = rsp.data;
          resolve(login_key);
        } else {
          reject();
          message.error(
            GetErrMsg(rsp.status.err_code, rsp.status.err_metadata.messages[0])
          );
        }
      })
      .catch((error) => {
        reject();
        message.error(JSON.stringify(error));
      });
  });
};
